module.exports = __webpack_public_path__ + "img/p1.500bf887.png";